"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAccountsStorage = exports.HighloadWalletV2 = exports.WalletV3Account = exports.GiverAccount = void 0;
const everscale_inpage_provider_1 = require("everscale-inpage-provider");
var Giver_1 = require("./Giver");
Object.defineProperty(exports, "GiverAccount", { enumerable: true, get: function () { return Giver_1.GiverAccount; } });
var WalletV3_1 = require("./WalletV3");
Object.defineProperty(exports, "WalletV3Account", { enumerable: true, get: function () { return WalletV3_1.WalletV3Account; } });
var HighloadWalletV2_1 = require("./HighloadWalletV2");
Object.defineProperty(exports, "HighloadWalletV2", { enumerable: true, get: function () { return HighloadWalletV2_1.HighloadWalletV2; } });
/**
 * @category AccountsStorage
 */
class SimpleAccountsStorage {
    /**
     * Creates new simple accounts storage.
     *
     * If no `defaultAccount` provided, uses first provided entry
     *
     * @param args
     */
    constructor(args = {}) {
        this.accounts = new Map();
        if (args.entries != null) {
            for (const account of args.entries) {
                if (this._defaultAccount == null) {
                    this._defaultAccount = account.address;
                }
                this.accounts.set(account.address.toString(), account);
            }
        }
        if (args.defaultAccount != null) {
            let defaultAccount;
            if (args.defaultAccount instanceof everscale_inpage_provider_1.Address) {
                defaultAccount = args.defaultAccount;
            }
            else {
                defaultAccount = new everscale_inpage_provider_1.Address(args.defaultAccount);
            }
            if (!this.accounts.has(defaultAccount.toString())) {
                throw new Error('Provided default account not found in storage');
            }
            this._defaultAccount = defaultAccount;
        }
    }
    get defaultAccount() {
        return this._defaultAccount;
    }
    set defaultAccount(value) {
        const address = value === null || value === void 0 ? void 0 : value.toString();
        if (address != null && !this.accounts.has(address)) {
            throw new Error('Account not found in storage');
        }
        this._defaultAccount = (value == null || value instanceof everscale_inpage_provider_1.Address) ? value : new everscale_inpage_provider_1.Address(value);
    }
    async getAccount(address) {
        return this.accounts.get(address.toString());
    }
    addAccount(account) {
        const address = account.address;
        this.accounts.set(address.toString(), account);
        return address;
    }
    hasAccount(address) {
        return this.accounts.has(address.toString());
    }
    removeAccount(address) {
        this.accounts.delete(address.toString());
    }
}
exports.SimpleAccountsStorage = SimpleAccountsStorage;
